// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Vanuatu from '../_raw/flag/icon_flag_vanuatu.png';

export default () => <img src={Vanuatu} alt="Vanuatu" />;
